import { cn } from '@poseidon/components/cn';
import React, { type ComponentProps } from 'react';

import { Scrollable } from '~/components/Scrollable';

type PaddedScrollableProps = ComponentProps<'div'> & {
  fullHeight?: boolean;
  fullWidth?: boolean;
  innerClassName?: string;
  className?: string;
};

export const PaddedScrollable = ({
  children,
  id,
  fullHeight,
  fullWidth,
  className,
  innerClassName,
}: PaddedScrollableProps) => {
  const classList = cn('flex flex-col px-8 py-2.5', innerClassName, {
    'min-h-full': fullHeight,
    'min-w-full flex-row w-auto': fullWidth,
  });
  return (
    <Scrollable id={id} className={className} innerClassName={classList}>
      {children}
    </Scrollable>
  );
};

export const SmallPaddedScrollable = ({
  children,
  id,
  fullHeight,
  fullWidth,
  innerClassName,
  className,
}: PaddedScrollableProps) => {
  const classList = cn('flex w-full flex-col p-4 py-2.5', innerClassName, {
    'min-h-full': fullHeight,
    'min-w-full flex-row w-auto': fullWidth,
  });

  return (
    <Scrollable id={id} className={className} innerClassName={classList}>
      {children}
    </Scrollable>
  );
};

export const Padded = ({ fullHeight, className, ...props }: PaddedScrollableProps) => {
  return <div className={cn('flex flex-col px-8 py-2.5', { 'min-h-full': fullHeight }, className)} {...props} />;
};

export const SmallPadded = ({ fullHeight, className, ...props }: PaddedScrollableProps) => {
  return <div className={cn('flex w-full flex-col p-4 py-2.5', { 'min-h-full': fullHeight }, className)} {...props} />;
};
